import React, { useMemo, useRef } from 'react'
import styles from './index.scss'
import classnames from 'classnames'
import { RightOutline } from 'antd-mobile-icons'
import View from './view'
import { transformItem } from './utils'

interface IDpPickerProps {
  columns: any[]
  multiple?: boolean
  disabled?: boolean
  title?: string
  onChange?: Function
  placeholder?: string
  value?: string
  customStyles?: React.CSSProperties
  View?: any
}

const DpMultiplePicker: React.FC<IDpPickerProps> = (props) => {
  const useRefPicker: any = useRef()
  const valueDesc = useMemo(() => {
    return props?.value && (typeof props?.value === 'string' ? props?.value?.split?.(',') : props?.value )
      ?.map(
        (_item) =>
          transformItem(
            props?.columns?.find(
              (node) => transformItem(node)?.value === _item,
            ),
          )?.label,
      )
      ?.join('、')
  }, [props?.value, props?.columns])
  return (
    <div className={classnames([styles['dp-picker-multiple'], { 'dp-picker-multiple': true } ])}>
      <div
        onClick={() => {
          if (!props?.disabled) {
            useRefPicker?.current?.setUpdateVisible?.()
          }
        }}
        className={styles['dp-picker-desc']}
      >
        <div
          className={
            classnames([styles['dp-picker-desc-body'], { [styles['dp-picker-desc-body--disabled']]: props?.disabled } ])
          }
        >
          {valueDesc || (<span className={styles['dp-picker-placeholder']}>{props?.placeholder || '请选择'}</span>)}
        </div>
        {!props?.disabled && <RightOutline className={styles['dp-picker-arrows']} />}
      </div>
      <View onRef={(e: any) => useRefPicker.current = e} {...props} />
    </div>
  )
}
DpMultiplePicker.View = View as any
export default DpMultiplePicker
